/* eslint-disable */
// prettier-ignore
import * as Types from '../../../../../../../../../graphql/__generated__';

import { DocumentNode } from 'graphql';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type InvestorFirms_UpdateContactMutationVariables = Types.Exact<{
  employeeKeyOrId: Types.Scalars['ID']['input'];
  firmKeyOrId: Types.Scalars['ID']['input'];
  input: Types.UpdateInvestorFirmEmployeeInput;
}>;

export type InvestorFirms_UpdateContactMutation = {
  readonly __typename?: 'Mutation';
  readonly updateInvestorFirmEmployee: {
    readonly __typename?: 'UpdateInvestorFirmEmployeePayload';
    readonly investorFirmContact?: {
      readonly __typename?: 'InvestorFirmContact';
      readonly name: string;
      readonly firmId: string;
      readonly investorEmployeeId: string;
      readonly investorEmployeeKey?: string | null;
      readonly email1?: string | null;
      readonly email2?: string | null;
      readonly phone1?: string | null;
      readonly phone2?: string | null;
      readonly fax1?: string | null;
      readonly fax2?: string | null;
      readonly address1?: string | null;
      readonly address2?: string | null;
      readonly titles?: ReadonlyArray<string> | null;
      readonly source?: string | null;
      readonly modifiedOn: string;
      readonly status: Types.RolodexRecordStatus;
    } | null;
  };
};

export type InvestorFirms_AdminUpdateContactMutationVariables = Types.Exact<{
  input: Types.AdminUpdateInvestorFirmEmployeeInput;
}>;

export type InvestorFirms_AdminUpdateContactMutation = {
  readonly __typename?: 'Mutation';
  readonly adminUpdateInvestorFirmEmployee?: {
    readonly __typename?: 'AdminUpdateInvestorFirmEmployeePayload';
    readonly investorFirmContact?: {
      readonly __typename?: 'InvestorFirmContact';
      readonly name: string;
      readonly firmId: string;
      readonly investorEmployeeId: string;
      readonly investorEmployeeKey?: string | null;
      readonly email1?: string | null;
      readonly email2?: string | null;
      readonly phone1?: string | null;
      readonly phone2?: string | null;
      readonly fax1?: string | null;
      readonly fax2?: string | null;
      readonly address1?: string | null;
      readonly address2?: string | null;
      readonly titles?: ReadonlyArray<string> | null;
      readonly source?: string | null;
      readonly modifiedOn: string;
      readonly status: Types.RolodexRecordStatus;
    } | null;
  } | null;
};

export const InvestorFirms_UpdateContactDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'InvestorFirms_UpdateContact' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'employeeKeyOrId' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'firmKeyOrId' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'UpdateInvestorFirmEmployeeInput' },
            },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'updateInvestorFirmEmployee' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'employeeKeyOrId' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'employeeKeyOrId' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'firmKeyOrId' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'firmKeyOrId' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'input' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'investorFirmContact' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'FragmentSpread',
                        name: { kind: 'Name', value: 'FirmInvestorContactsGridItem' },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'FirmInvestorContactsGridItem' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'InvestorFirmContact' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'name' } },
          { kind: 'Field', name: { kind: 'Name', value: 'firmId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'investorEmployeeId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'investorEmployeeKey' } },
          { kind: 'Field', name: { kind: 'Name', value: 'email1' } },
          { kind: 'Field', name: { kind: 'Name', value: 'email2' } },
          { kind: 'Field', name: { kind: 'Name', value: 'phone1' } },
          { kind: 'Field', name: { kind: 'Name', value: 'phone2' } },
          { kind: 'Field', name: { kind: 'Name', value: 'fax1' } },
          { kind: 'Field', name: { kind: 'Name', value: 'fax2' } },
          { kind: 'Field', name: { kind: 'Name', value: 'address1' } },
          { kind: 'Field', name: { kind: 'Name', value: 'address2' } },
          { kind: 'Field', name: { kind: 'Name', value: 'titles' } },
          { kind: 'Field', name: { kind: 'Name', value: 'source' } },
          { kind: 'Field', name: { kind: 'Name', value: 'modifiedOn' } },
          { kind: 'Field', name: { kind: 'Name', value: 'status' } },
        ],
      },
    },
  ],
} as unknown as DocumentNode;
export type InvestorFirms_UpdateContactMutationFn = Apollo.MutationFunction<
  InvestorFirms_UpdateContactMutation,
  InvestorFirms_UpdateContactMutationVariables
>;

/**
 * __useInvestorFirms_UpdateContactMutation__
 *
 * To run a mutation, you first call `useInvestorFirms_UpdateContactMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useInvestorFirms_UpdateContactMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [investorFirmsUpdateContactMutation, { data, loading, error }] = useInvestorFirms_UpdateContactMutation({
 *   variables: {
 *      employeeKeyOrId: // value for 'employeeKeyOrId'
 *      firmKeyOrId: // value for 'firmKeyOrId'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useInvestorFirms_UpdateContactMutation(
  baseOptions?: Apollo.MutationHookOptions<
    InvestorFirms_UpdateContactMutation,
    InvestorFirms_UpdateContactMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    InvestorFirms_UpdateContactMutation,
    InvestorFirms_UpdateContactMutationVariables
  >(InvestorFirms_UpdateContactDocument, options);
}
export type InvestorFirms_UpdateContactMutationHookResult = ReturnType<
  typeof useInvestorFirms_UpdateContactMutation
>;
export type InvestorFirms_UpdateContactMutationResult =
  Apollo.MutationResult<InvestorFirms_UpdateContactMutation>;
export type InvestorFirms_UpdateContactMutationOptions = Apollo.BaseMutationOptions<
  InvestorFirms_UpdateContactMutation,
  InvestorFirms_UpdateContactMutationVariables
>;
export const InvestorFirms_AdminUpdateContactDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'InvestorFirms_AdminUpdateContact' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'AdminUpdateInvestorFirmEmployeeInput' },
            },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'adminUpdateInvestorFirmEmployee' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'input' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'investorFirmContact' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'FragmentSpread',
                        name: { kind: 'Name', value: 'FirmInvestorContactsGridItem' },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'FirmInvestorContactsGridItem' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'InvestorFirmContact' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'name' } },
          { kind: 'Field', name: { kind: 'Name', value: 'firmId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'investorEmployeeId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'investorEmployeeKey' } },
          { kind: 'Field', name: { kind: 'Name', value: 'email1' } },
          { kind: 'Field', name: { kind: 'Name', value: 'email2' } },
          { kind: 'Field', name: { kind: 'Name', value: 'phone1' } },
          { kind: 'Field', name: { kind: 'Name', value: 'phone2' } },
          { kind: 'Field', name: { kind: 'Name', value: 'fax1' } },
          { kind: 'Field', name: { kind: 'Name', value: 'fax2' } },
          { kind: 'Field', name: { kind: 'Name', value: 'address1' } },
          { kind: 'Field', name: { kind: 'Name', value: 'address2' } },
          { kind: 'Field', name: { kind: 'Name', value: 'titles' } },
          { kind: 'Field', name: { kind: 'Name', value: 'source' } },
          { kind: 'Field', name: { kind: 'Name', value: 'modifiedOn' } },
          { kind: 'Field', name: { kind: 'Name', value: 'status' } },
        ],
      },
    },
  ],
} as unknown as DocumentNode;
export type InvestorFirms_AdminUpdateContactMutationFn = Apollo.MutationFunction<
  InvestorFirms_AdminUpdateContactMutation,
  InvestorFirms_AdminUpdateContactMutationVariables
>;

/**
 * __useInvestorFirms_AdminUpdateContactMutation__
 *
 * To run a mutation, you first call `useInvestorFirms_AdminUpdateContactMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useInvestorFirms_AdminUpdateContactMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [investorFirmsAdminUpdateContactMutation, { data, loading, error }] = useInvestorFirms_AdminUpdateContactMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useInvestorFirms_AdminUpdateContactMutation(
  baseOptions?: Apollo.MutationHookOptions<
    InvestorFirms_AdminUpdateContactMutation,
    InvestorFirms_AdminUpdateContactMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    InvestorFirms_AdminUpdateContactMutation,
    InvestorFirms_AdminUpdateContactMutationVariables
  >(InvestorFirms_AdminUpdateContactDocument, options);
}
export type InvestorFirms_AdminUpdateContactMutationHookResult = ReturnType<
  typeof useInvestorFirms_AdminUpdateContactMutation
>;
export type InvestorFirms_AdminUpdateContactMutationResult =
  Apollo.MutationResult<InvestorFirms_AdminUpdateContactMutation>;
export type InvestorFirms_AdminUpdateContactMutationOptions = Apollo.BaseMutationOptions<
  InvestorFirms_AdminUpdateContactMutation,
  InvestorFirms_AdminUpdateContactMutationVariables
>;
